<template>
  <TheAdmin :color="true" title="대시보드" description="모든 정보를 한눈에 확인해보세요.">
    <a-card class="mt">
      <a-button
        :disabled="this.isCheckout"
        type="danger"
        icon="calculator"
        @click="onCheckout"
      >{{ this.isCheckout ? '정산됨' : '정산' }}</a-button>
    </a-card>
    <a-row :gutter="16" type="flex">
      <a-col :md="12" :span="24" class="mt">
        <a-spin tip="로딩 중..." :spinning="isLoading">
          <a-card title="잔액 설정">
            <a-form-item label="잔액:">
              <a-input-number
                :formatter="
                  value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                v-model="amount"
                style="width: 90%; margin-right: 5px;"
              />원
            </a-form-item>
            <a-card>
              <a-form-item label="계산">
                <a-input-number
                  :formatter="
                    value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  v-model="amountDiff"
                  style="width: 90%; margin-right: 5px;"
                />원
              </a-form-item>
              <a-button-group>
                <a-button type="primary" icon="plus" @click="updateAmountDiff(true)">더하기</a-button>
                <a-button type="danger" icon="minus" @click="updateAmountDiff(false)">빼기</a-button>
              </a-button-group>
            </a-card>
            <a-button
              style="margin-top: 30px;"
              :loading="isLoading"
              @click="onChangeAmount"
              type="primary"
              icon="save"
            >적용</a-button>
          </a-card>
        </a-spin>
      </a-col>
      <a-col :md="12" :span="24" class="mt">
        <a-spin tip="로딩 중..." :spinning="isLoading">
          <a-card title="송금(차감도 가능)">
            <a-switch
              @change="
                autoComplete = [];
                search = '';
              "
              checkedChildren="사용자"
              unCheckedChildren="사입삼촌"
              v-model="transform.isUser"
            />
            <a-form-item :label="(transform.isUser ? '사용자' : '사입삼촌') + ':'">
              <a-auto-complete
                placeholder="검색"
                v-model="search"
                @search="onSearch"
                :dataSource="autoComplete"
                v-on:keypress.native="onSearchChange"
                style="width: 100%"
              >
                <a-input>
                  <a-icon slot="suffix" type="search" @click="onSearch" />
                </a-input>
              </a-auto-complete>
            </a-form-item>
            <a-form-item label="금액:">
              <a-input-number
                :formatter="
                  value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                v-model="transform.amount"
                style="width: 90%; margin-right: 5px;"
              />원
            </a-form-item>
            <a-card>
              <a-form-item label="계산">
                <a-input-number
                  :formatter="
                    value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                  v-model="transform.amountDiff"
                  style="width: 90%; margin-right: 5px;"
                />원
              </a-form-item>
              <a-button-group>
                <a-button type="primary" icon="plus" @click="updateAmountDiff(true, true)">더하기</a-button>
                <a-button type="danger" icon="minus" @click="updateAmountDiff(false, true)">빼기</a-button>
              </a-button-group>
            </a-card>
            <a-form-item label="사유(충전시 '충전' 작성):">
              <a-input v-model="transform.reason" placeholder="사유" />
            </a-form-item>
            <a-button
              style="margin-top: 30px;"
              :loading="isLoading"
              @click="onTransform"
              type="primary"
              icon="arrow-right"
            >적용</a-button>
          </a-card>
        </a-spin>
      </a-col>
      <a-col :span="24" class="mt">
        <a-spin tip="로딩 중..." :spinning="isLoading">
          <a-card title="공지 사항">
            <a-form-item label="활성화:">
              <a-switch v-model="notice.isEnabled" />
            </a-form-item>
            <a-form-item label="제목:" v-if="notice.isEnabled">
              <a-input v-model="notice.title" />
            </a-form-item>
            <a-form-item label="내용:" v-if="notice.isEnabled">
              <a-textarea v-model="notice.contents" />
            </a-form-item>
            <a-button
              style="margin-top: 30px;"
              :loading="isLoading"
              @click="onChangeNotice"
              type="primary"
              icon="save"
            >적용</a-button>
          </a-card>
        </a-spin>
      </a-col>
    </a-row>
  </TheAdmin>
</template>
<script>
import TheAdmin from "@/components/Admin/TheAdmin";
import Axios from "axios";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";

export default {
  name: "AdminDashboard",
  components: { TheAdmin },
  mounted() {
    this.getNotice();
  },
  methods: {
    onSearchChange(e) {
      if (e.key !== "Enter") return;
      this.onSearch();
    },
    async onSearch() {
      if (this.search === "") return;
      const currentTime = new Date();
      if (currentTime - this.latestComplete <= 300) return;
      this.latestComplete = currentTime;
      const { data } = await Axios.get(
        `${config.hostname}/v1/admin/transform?q=${this.search}&type=${
          this.transform.isUser ? "account" : "uncle"
        }`,
        { withCredentials: true }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.autoComplete = data.account.map(
              i => `${i.username}(${i.idx})`
            );
            break;
        }
      }
    },
    async onTransform() {
      try {
        const match = this.search.match(/^.*\((.*)\)$/i);
        if (match === null || match.length < 2) {
          this.search = "";
          return config.alert.mixin({
            type: "error",
            title: "대상을 선택해주세요."
          });
        }

        if (!this.transform.amount) {
          return config.alert.mixin({
            type: "error",
            title: "금액을 입력해주세요."
          });
        }

        const { data } = await Axios.post(
          `${config.hostname}/v1/admin/transform`,
          {
            idx: match[1],
            amount: this.transform.amount,
            reason: this.transform.reason
          },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.search = "";
              this.transform.amount = 0;
              this.transform.reason = "충전";
              config.alert.mixin({
                type: "success",
                title: "성공적으로 반영되었습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "송금할 수 없습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "송금할 수 없습니다."
        });
      }
    },
    async onChangeAmount() {
      try {
        this.isLoading = true;
        const { amount } = this;
        const { data } = await Axios.post(
          `${config.hostname}/v1/admin/amount`,
          { amount },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.amount = data.amount;
              config.alert.mixin({
                type: "success",
                title: "성공적으로 반영되었습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "잔액을 수정할 수 없습니다."
              });
              break;
          }
        }
      } catch (e) {
        config.alert.mixin({
          type: "error",
          title: "잔액을 수정할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.isLoading = false;
    },
    updateAmountDiff(isPlus, isTransform = false) {
      if (isTransform) {
        if (this.transform.amountDiff === 0) return;
        const amount = parseInt(this.transform.amount);
        if (isPlus) {
          this.transform.amount = amount + this.transform.amountDiff;
        } else {
          this.transform.amount = amount - this.transform.amountDiff;
        }
        this.transform.amountDiff = 0;
      }

      if (this.amountDiff === 0) return;
      const amount = parseInt(this.amount);
      if (isPlus) {
        this.amount = amount + this.amountDiff;
      } else {
        this.amount = amount - this.amountDiff;
      }
      this.amountDiff = 0;
    },
    viewUser(idx) {
      this.$router.push("/admin/users/" + idx);
    },
    async getNotice() {
      try {
        this.isLoading = true;
        const { data } = await Axios.get(`${config.hostname}/v1/admin/notice`, {
          withCredentials: true
        });

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.notice = data.notice;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "공지 사항을 가져올 수 없습니다."
              });
              break;
          }
        }
      } catch (e) {
        config.alert.mixin({
          type: "error",
          title: "공지 사항을 가져올 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.isLoading = false;
    },
    async onChangeNotice() {
      try {
        this.isLoading = true;
        const { data } = await Axios.post(
          `${config.hostname}/v1/admin/notice`,
          this.notice,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.notice = data.notice;
              config.alert.mixin({
                type: "success",
                title: "공지 사항을 수정하였습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "공지 사항을 수정할 수 없습니다."
              });
              break;
          }
        }
      } catch (e) {
        config.alert.mixin({
          type: "error",
          title: "공지 사항을 수정할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.isLoading = false;
    },
    onCheckout() {
      const self = this;
      this.$confirm({
        title: `정산`,
        content: "정말로 정산 처리하시겠습니까?\n취소할 수 없습니다.",
        okText: "네, 정산합니다.",
        okType: "danger",
        cancelText: "아니요",
        onOk() {
          self.onCheckoutReq();
        },
        onCancel() {}
      });
    },
    async onCheckoutReq() {
      try {
        const { data } = await Axios.get(
          `${config.hostname}/v1/admin/auth/calculate`,
          {
            withCredentials: true
          }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.isCheckout = true;
              config.alert.mixin({
                type: "success",
                title: "정산 처리하였습니다."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "정산 처리에 문제가 발생하였습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "정산 처리할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
    }
  },
  data() {
    return {
      latestComplete: new Date(),
      searchs: [],
      autoComplete: [],
      search: "",
      isLoading: false,
      amountDiff: 0,
      notice: {
        isEnabled: false,
        title: "",
        contents: ""
      },
      isCheckout: false,
      transform: {
        isUser: true,
        amount: 0,
        amountDiff: 0,
        reason: "충전"
      }
    };
  },
  computed: {
    amount: {
      get() {
        return this.$store.state.admin.amount;
      },
      set(value) {
        this.$store.commit("ADMIN_UPDATE_AMOUNT", value);
      }
    }
  }
};
</script>
